import { BaseDto } from "@models/base/baseDto.model"

export class IndiceAjusteContratoFilter extends BaseDto{

  public fechaDesde!: string
  public fechaHasta!: string
  public idsTipoAjusteContrato!: number[]
}

